import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import GlobalStyle from './styles/GlobalStyle';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Pages
import Home from './Pages/Home';
import Shop from './Pages/Shop';
import About from './Pages/About';
import Media from './Pages/Media';
import Contact from './Pages/Contact';
import Time from './Pages/Time';
import Blog from './Pages/Blog';

// Products
import ClassicProduct from './Pages/products/ClassicProduct';
import WhiteboardProduct from './Pages/products/WhiteboardProduct';
import GenericProduct from './Pages/products/GenericProduct';

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Router>
      <Header />
      <main>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/shop" component={Shop} />
          <Route path="/about" component={About} />
          <Route path="/media" component={Media} />
          <Route path="/contact" component={Contact} />
          <Route path="/time" component={Time} />
          <Route path="/blog" component={Blog} />
          <Route path="/newcalendar_classic">
            <ClassicProduct
              price={25}
              name="The New Calendar Classic"
              slug="newcalendar_classic"
              image="https://res.cloudinary.com/dqy3fktlv/image/upload/v1700665978/EKJClknXYAgIzI2_pk6dy9.jpg"
              description="The original perpetual wall calendar."
            />
          </Route>
          <Route path="/newcalendar_wallmap">
            <WhiteboardProduct
              price={150}
              name="New Calendar Wall Map"
              slug="newcalendar_wallmap"
              image="https://res.cloudinary.com/dqy3fktlv/image/upload/v1734522897/IMG_7101copycopy_z9ck6d.jpg"
              imageTwo="https://res.cloudinary.com/dqy3fktlv/image/upload/v1734542869/IMG_7077crop_lghhnb.jpg"
              description="Large format dry-erase planning calendar."
            />
          </Route>
          {/* Apparel - Tees */}
          <Route path="/white-logo-black-tee">
            <GenericProduct
              productId="10714278986040"
              name="White Logo on Black Tee"
              price={16}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-classic-tee-dark-heather-front-6a1c23092be3e.jpg?v=1780228882"
              description="Classic unisex tee with The New Calendar logo. Comfortable cotton blend, available in multiple sizes."
              category="Tees"
            />
          </Route>
          <Route path="/black-logo-white-tee">
            <GenericProduct
              productId="10714278396216"
              name="Black Logo on White Tee"
              price={16}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-classic-tee-ash-front-6a1c212b8374c.jpg?v=1780228407"
              description="Classic unisex tee with The New Calendar logo. Comfortable cotton blend, available in multiple sizes."
              category="Tees"
            />
          </Route>
          {/* Apparel - Crop & Polo */}
          <Route path="/crop-top">
            <GenericProduct
              productId="10714276528440"
              name="New Calendar Crop Top"
              price={30}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/womens-crop-top-ecru-front-6a1c1aca314e6.jpg?v=1780226779"
              description="Stylish crop top featuring The New Calendar logo. Perfect for warm seasons."
              category="Tops"
            />
          </Route>
          <Route path="/polo-shirt">
            <GenericProduct
              productId="10714273579320"
              name="New Calendar Polo Shirt"
              price={40}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-pique-polo-shirt-navy-front-6a1c1109df000.jpg?v=1780224282"
              description="Professional piqué polo with embroidered logo. Perfect for the office or casual outings."
              category="Polos"
            />
          </Route>
          {/* Apparel - Sun Shirts */}
          <Route path="/new-calendar-sun-shirt">
            <GenericProduct
              productId="10714273415480"
              name="New Calendar Sun Shirt"
              price={72}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c102535c64.jpg?v=1780224068"
              description="Lightweight all-over print sun shirt featuring The New Calendar design. UPF protection meets revolutionary style."
              category="Sun Shirts"
            />
          </Route>
          <Route path="/betsy-ross-sun-shirt">
            <GenericProduct
              productId="10714272727352"
              name="The Betsy Ross Sun Shirt"
              price={72}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c0c4d9dc18.jpg?v=1780223095"
              description="Patriotic all-over print sun shirt with classic American styling. UPF protection for outdoor adventures."
              category="Sun Shirts"
            />
          </Route>
          <Route path="/peace-time-sun-shirt">
            <GenericProduct
              productId="10714273186104"
              name="Peace Time Sun Shirt"
              price={72}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c0e4a5e711.jpg?v=1780223612"
              description="Peaceful vibes all-over print sun shirt. UPF protection for your outdoor adventures."
              category="Sun Shirts"
            />
          </Route>
          <Route path="/elite-officer-sun-shirt">
            <GenericProduct
              productId="10714277773624"
              name="Elite Officer Sun Shirt"
              price={72}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c1f354e3a6.jpg?v=1780227932"
              description="Premium all-over print sun shirt with tropical Seychelle design. UPF protection in style."
              category="Sun Shirts"
            />
          </Route>
          {/* Apparel - Hoodies */}
          <Route path="/white-logo-black-hoodie">
            <GenericProduct
              productId="10714276856120"
              name="White Logo on Black Hoodie"
              price={40}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-heavy-blend-hoodie-black-front-6a1c1ba399d73.jpg?v=1780226994"
              description="Cozy heavy blend hoodie with The New Calendar logo. Perfect for cool seasons and casual wear."
              category="Hoodies"
            />
          </Route>
          <Route path="/black-logo-gray-hoodie">
            <GenericProduct
              productId="10714277183800"
              name="Black Logo on Gray Hoodie"
              price={40}
              image="https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-heavy-blend-hoodie-ash-front-6a1c1c1fcccbd.jpg?v=1780227125"
              description="Cozy heavy blend hoodie with The New Calendar logo. Perfect for cool seasons and casual wear."
              category="Hoodies"
            />
          </Route>
        </Switch>
      </main>
      <Footer />
    </Router>
  </ThemeProvider>
);

export default App;
